const STRIPE_CHECKOUT_HOSTNAME = 'checkout.stripe.com';

export function trustedStripeCheckoutUrl(value: string): string {
  const url = new URL(value);

  if (url.protocol !== 'https:' || url.hostname !== STRIPE_CHECKOUT_HOSTNAME) {
    throw new Error('Unexpected checkout destination');
  }

  return url.toString();
}
